const groupDigits = (num) => {
  let result = num.split();
  if (result[0] && result[0].length >= 3) {
    result[0] = result[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
  }
  return result[0].trim();
};

export default groupDigits;